import { TextStyles } from '../../types';

const baseStyle = {
  color: 'text-emphasis',
};

const sizes = {
  h0: {
    apply: `textStyles.${TextStyles.H0}`,
  },
  h1: {
    apply: `textStyles.${TextStyles.H1}`,
  },
  h2: {
    apply: `textStyles.${TextStyles.H2}`,
  },
  h3: {
    apply: `textStyles.${TextStyles.H3}`,
  },
  h4: {
    apply: `textStyles.${TextStyles.H4}`,
  },
  h5: {
    apply: `textStyles.${TextStyles.H5}`,
  },
  h6: {
    apply: `textStyles.${TextStyles.H6}`,
  },
};

export const Heading = {
  baseStyle,
  sizes,
  variants: sizes,
};
